import React from "react";
import { GlobalBarChart } from "../../../../../components/Dashboard/GlobalComponents/GlobalBarChart";
import { useSelector } from "react-redux";

const Chart = () => {
  const { loading, goalData, goalStatuses, goalStatusFilterTabLoading } =
    useSelector((state) => state.appraisal);

  const goalList = Array.isArray(goalData?.data) ? goalData.data : [];

  const chartData = goalList.map((goal, index) => ({
    label: `G${index + 1}`,
    value: goal.completedPercentage ?? 0, // fallback to 0 if undefined
  }));

  return (
    <div>
      <GlobalBarChart title={"Goals Over view"} chartData={chartData} />
    </div>
  );
};

export default Chart;
